<ng-container
  *ngIf="selectedDepartmentTotals$ | async as selectedDepartmentTotals"
>
  <table class="department-totals-table">
    <thead>
      <th>
        <span class="totals-item-head">total jobs</span>
      </th>
      <th>
        <span class="totals-item-head">total time (dd:hh:mm:ss)</span>
      </th>
      <th>
        <span class="totals-item-head">total cut (m)</span>
      </th>
      <th>
        <span class="totals-item-head">total crease (m)</span>
      </th>
      <th>
        <span class="totals-item-head">average (m)</span>
      </th>
    </thead>
    <tbody>
      <tr>
        <td>
          <span class="totals-item">{{ selectedDepartmentTotals.count }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedDepartmentTotals.totalTimeAsHHmmss
          }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedDepartmentTotals.cutMetersAsString
          }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedDepartmentTotals.creaseMetersAsString
          }}</span>
        </td>
        <td>
          <span class="totals-item">{{
            selectedDepartmentTotals.cutMetersPlusCreaseMetersDividedByTotalTimeAsString
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>
